import Lemit from './Index.vue';

export const routes = [
  {
    path: 'consultas-dados',
    alias: 'consulta-lemit',
    name: 'talkvia_lemit',
    meta: { permissions: ['administrator', 'campaign_manage'] },
    component: Lemit,
  },
];
